import React from "react";
import { Dialog, DialogContent, Button, CircularProgress } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/DeleteAccountDialog.css";

const DeleteAccountDialog = ({
  open,
  onClose,
  subtitle,
  username,
  onClickDelete,
  isLoading,
}) => {
  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "delete-account-dialog-container",
        sx: { borderRadius: "20px" },
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="delete-account-dialog-close"
          onClick={onClose}
        />
        <div className="delete-account-dialog-content">
          <div
            className="delete-account-dialog-title-container"
            style={{ marginBottom: "60px" }}
          >
            <div className="delete-account-dialog-title">Delete</div>
            <div className="delete-account-dialog-subtitle">
              {username
                ? `Do you want to delete ${username}?`
                : `Do you want to delete this ${subtitle ? subtitle : "user"}?`}
            </div>
          </div>
          <Button
            variant="contained"
            color="delete"
            onClick={!isLoading ? onClickDelete : null}
            style={{ width: "245px" }}
            endIcon={
              isLoading ? <CircularProgress size={30} color="inherit" /> : null
            }
          >
            Delete
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteAccountDialog;
